var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationStIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66675,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECE9FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66675,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F5F3FF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 18.5575V19.7C30.6667 21.3802 30.6667 22.2202 30.9937 22.862C31.2813 23.4265 31.7403 23.8854 32.3048 24.173C32.9465 24.5 33.7866 24.5 35.4667 24.5L36.6092 24.5M30.6667 18.5575C30.2732 18.5 29.8027 18.5 29.0158 18.5H27.0667C24.8265 18.5 23.7064 18.5 22.8508 18.936C22.0981 19.3195 21.4862 19.9314 21.1027 20.684C20.6667 21.5397 20.6667 22.6598 20.6667 24.9V32.1C20.6667 34.3402 20.6667 35.4603 21.1027 36.316C21.4862 37.0686 22.0981 37.6805 22.8508 38.064C23.7064 38.5 24.8265 38.5 27.0667 38.5H30.2667C32.507 38.5 33.6271 38.5 34.4827 38.064C35.2354 37.6805 35.8473 37.0686 36.2308 36.316C36.6667 35.4603 36.6667 34.3402 36.6667 32.1V26.151C36.6667 25.364 36.6667 24.8935 36.6092 24.5M30.6667 18.5575C30.7625 18.5715 30.8536 18.5889 30.9437 18.6105C31.3518 18.7085 31.742 18.8701 32.0999 19.0894C32.5036 19.3368 32.8495 19.6827 33.5413 20.3745L34.7922 21.6255C35.484 22.3173 35.8299 22.6632 36.0773 23.0669C36.2966 23.4247 36.4582 23.8149 36.5562 24.2231C36.5778 24.3131 36.5952 24.4043 36.6092 24.5M24.6667 29.5H32.6667M24.6667 33.5H29.6667",
    stroke: "#875BF7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStIcon);
export default __webpack_public_path__ + "static/media/application_stIcon.42d797b203d95260f0cf54864dc4c957.svg";
export { ForwardRef as ReactComponent };